












































































import { Component, Vue, Prop } from 'vue-property-decorator';
import CharacterIcon from '@/components/parts/CharacterIcon.vue';
import KmyChatTagText from '@/components/parts/KmyChatTagText.vue';
import * as api from '@/api/api';
import * as def from '@/common/definitions';
import ArrayUtil from '@/models/common/arrayutil';
import NotificationService from '../../services/notificationservice';

@Component({
  components: {
    CharacterIcon,
    KmyChatTagText,
  },
})
export default class ChatMessageItem extends Vue {
  @Prop() public message!: api.ChatMessage;
  @Prop() public countries!: api.Country[];
  @Prop() public mutes!: api.Mute[];
  @Prop() public muteKeyword!: api.MuteKeyword;
  @Prop({
    default: false,
  }) public canSendPrivate!: boolean;
  @Prop({
    default: 0,
  }) public myCharacterId!: number;
  @Prop({
    default: false,
  }) public canSendOtherCountry!: boolean;
  @Prop({
    default: 0,
  }) public myCountryId!: number;
  @Prop({
    default: false,
  }) public isLoading!: boolean;
  @Prop({
    default: false,
  }) public isIssueLink!: boolean;
  private isOpenReports: boolean = false;
  private isShowForce: boolean = false;
  private isMuting: boolean = false;
  private iconBaseUri: string = def.UPLOADED_ICONS_HOST;

  private get countryColor(): number {
    const country = ArrayUtil.find(this.countries, this.message.characterCountryId);
    if (country) {
      return country.colorId;
    } else {
      return 0;
    }
  }

  private get countryName(): string {
    const country = ArrayUtil.find(this.countries, this.message.characterCountryId);
    if (country) {
      return country.name;
    } else {
      return '無所属';
    }
  }

  private get isCharacterMuted(): boolean {
    if (this.message.character) {
      const chara = this.message.character;
      return this.mutes.some((m) => m.targetCharacterId === chara.id);
    }
    return false;
  }

  private get isMessageMuted(): boolean {
    return api.MuteKeyword.isMute(this.muteKeyword, this.message.message);
  }

  private get isReported(): boolean {
    return this.mutes.some((m) => m.chatMessageId === this.message.id && m.type === api.Mute.typeReported);
  }

  private muteCharacter(status: boolean) {
    if (this.message.character) {
      const chara = this.message.character;
      this.isMuting = true;
      api.Api.muteCharacter(status ? api.Mute.typeMuted : api.Mute.typeNone, chara.id)
        .then(() => {
          NotificationService.muted.notify();
          this.isShowForce = false;
          this.isOpenReports = false;
        })
        .catch(() => NotificationService.muteFailed.notify())
        .finally(() => this.isMuting = false);
    }
  }

  private reportMessage(status: boolean) {
    this.isMuting = true;
    api.Api.reportChatMessage(status ? api.Mute.typeReported : api.Mute.typeNone, this.message.id)
      .then(() => {
        NotificationService.reported.notify();
        this.isShowForce = false;
        this.isOpenReports = false;
      })
      .catch((ex) => {
        if (ex.data) {
          if (ex.data.code === api.ErrorCode.blockedActionError) {
            NotificationService.actionBlocked.notify();
          } else {
            NotificationService.reportFailed.notify();
          }
        } else {
          NotificationService.reportFailed.notify();
        }
      })
      .finally(() => this.isMuting = false);
  }
}
